/**
 * Created by Viacheslav Stepanian on 23.06.2026
 */

const HungryGamesMerge3Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("hungryGamesStart", (mission) => {
            if (Mission.GetMissionType(mission.getType()) === Mission.TYPE_HUNGRY_GAMES) {
                mission.logic.startCompetition();
                this.checkCustomer();
            }
        });

        cleverapps.missionManager.on("hungryGamesCompetitionStarted", (mission) => {
            if (Mission.GetMissionType(mission.getType()) === Mission.TYPE_HUNGRY_GAMES) {
                this.focusOnCustomer();
            }
        });

        cleverapps.missionManager.on("hungryGamesLose", (mission) => {
            if (Mission.GetMissionType(mission.getType()) === Mission.TYPE_HUNGRY_GAMES) {
                this.logPlayedTime(mission, Mission.EVENTS.MISSION_LOSE_TIME, mission.result + 1);
                this.checkCustomer();
            }
        });

        cleverapps.missionManager.on("hungryGamesWin", (mission) => {
            if (Mission.GetMissionType(mission.getType()) === Mission.TYPE_HUNGRY_GAMES) {
                this.logPlayedTime(mission, Mission.EVENTS.MISSION_WIN_TIME, HungryGamesLogic.LEVELS_AMOUNT);
            }
        });

        cleverapps.missionManager.on("complete", (mission) => {
            if (Mission.GetMissionType(mission.getType()) === Mission.TYPE_HUNGRY_GAMES) {
                this.checkCustomer();
            }
        });

        cleverapps.eventBus.on("locationInitStage", () => {
            this.checkCustomer();
        });
    },

    focusOnCustomer: function () {
        const customer = HungryGamesCustomer.findCustomer();
        const unit = customer && customer.unit;
        if (!unit) {
            return;
        }

        cleverapps.focusManager.display({
            focus: "HungryGamesFocusCustomer",
            stack: true,
            action: (f) => {
                Map2d.currentMap.focusOnUnit(unit, {
                    allowScrollWithFocus: true,
                    skipFocusReport: true,
                    callback: f
                });
            }
        });
    },

    logPlayedTime: function (mission, event, stages) {
        const playedTime = Math.max(0, Math.min(Date.now() - mission.logic.competitionStart, stages * HungryGamesCustomer.LEVEL_DURATION));
        mission.logic.logEvent(event, { value: Math.round(playedTime / 1000) });
    },

    refreshMineables: function () {
        if (!Map2d.currentMap) {
            return;
        }

        Map2d.currentMap.listAvailableUnits((unit) => unit.findComponent(Mineable)).forEach((unit) => {
            unit.findComponent(Mineable).onUpdateState();
        });
    },

    checkCustomer: function () {
        if (!Map2d.currentMap) {
            return;
        }

        this.refreshMineables();

        if (Map2dLocation.currentLocation.quests.applyDynamicFilter) {
            Map2dLocation.currentLocation.quests.applyDynamicFilter();
        }

        const mission = HungryGamesCustomer.getMission();
        const customer = HungryGamesCustomer.findCustomer();
        const unit = customer && customer.unit;

        if (customer && (customer.losing || customer.completing)) {
            return;
        }

        if (!mission || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE) {
            if (unit) {
                unit.remove();
            }
            Map2d.currentMap.listAvailableUnits({ code: "hungrygames" }).forEach((leftover) => {
                leftover.remove();
            });
            return;
        }

        if (!unit) {
            this.spawnCustomer();
        }
    },

    spawnCustomer: function () {
        const region = Map2d.currentMap.regions.hungry;
        const slot = region.positions.find((position) => !Map2d.currentMap.getUnit(position.x, position.y));
        if (!slot) {
            return;
        }

        const unit = new Unit({ code: "hungry", stage: 0 });
        unit.setPosition(slot.x, slot.y);
        Map2d.currentMap.add(Map2d.LAYER_UNITS, unit.x, unit.y, unit);
        Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
        Map2d.currentMap.onUnitAvailable(unit);

        const customer = unit.findComponent(Customer);
        customer.restore();
        customer.checkRecipe();
    }
};

cleverapps.whenAllInitialized(() => {
    HungryGamesMerge3Adapter.SubscribeToEvents();
});
cleverapps.InitByFeature["hungry_games"] = function () {
    cleverapps.tutorial.register(HungryGamesExchangeTutorial());
    cleverapps.tutorial.register(HungryGamesSourceTutorial());
};
